import { pxToRem } from './units';
export default function getSpacing(shortCode, theme) {
  if (shortCode === undefined || shortCode === null) {
    return undefined;
  }
  if (typeof shortCode !== 'number' && typeof shortCode !== 'string' || shortCode === '0') {
    return '0';
  }
  if (typeof shortCode === 'number') {
    return pxToRem(shortCode);
  }
  if (shortCode.charAt(0) === '-') {
    return "-".concat(getSpacing(shortCode.substring(1), theme));
  } else {
    if (shortCode in theme.globals.spacing) {
      return theme.globals.spacing[shortCode];
    } else {
      return shortCode;
    }
  }
}